import { useQuery } from '@tanstack/react-query';

import style from './Center.module.scss';

import { EntryTypeBlockStatus } from 'chaika-enums';
import { Optional } from 'chaika-frontend-types/frontend-cms';

import { translate } from '@chaika/i18n/helper';

import { blockQueryOptions } from '../../queries/blockQueries';

export interface CenterParams {
    blockId: string;
    version: number;
}

export function Center({ blockId, version }: CenterParams) {
    const { data: block } = useQuery(blockQueryOptions.version(blockId, version));

    return (
        <div className={style.root}>
            <div className={style.title}>{block?.title}</div>
            <div className={style.status}>{getStatusTitle(block?.status)}</div>
        </div>
    );
}

function getStatusTitle(status: Optional<EntryTypeBlockStatus>): string {
    switch (status) {
        case EntryTypeBlockStatus.Active:
            return translate('activeMasculine');
        case EntryTypeBlockStatus.Draft:
            return translate('draft');
        case EntryTypeBlockStatus.Archived:
            return translate('archive');
        default:
            return '';
    }
}
